import validatorjs from 'validatorjs';

function DimensionsStepEditForm() {
	var Validator = validatorjs;
	Validator.register(
		'numericMinValue',
		value => {
			return 1 / value > 0;
		},
		'NUMERICMINVALUE'
	);
	Validator.register(
		'invalidCharacter',
		value => {
			return value[value.length - 1] !== '.' && !value.toString().includes('e');
		},
		'INVALIDCHARACTER'
	);
	Validator.register(
		'notZero',
		value => {
			return value != 0;
		},
		'NOTZEROVALUE'
	);
	Validator.register(
		'decimalLength',
		value => {
			var decimal = value.toString().split('.')[1];
			if (decimal) {
				return decimal.length <= 2;
			}
			return true;
		},
		'MINIMUMLENGHT'
	);

	return {
		fields: [
			'dimensionsStep.width',
			'dimensionsStep.length',
			'dimensionsStep.height',
			'dimensionsStep.dimensionUnit',
			'dimensionsStep.weight',
			'dimensionsStep.weightUnit',
			'dimensionsStep.box',
			'dimensionsStep.automaticBox',
			'dimensionsStep.ounces',
			'dimensionsStep.pounds',
		],
		labels: {
			'dimensionsStep.width': 'PRODUCTVIEW.WIDTH',
			'dimensionsStep.length': 'PRODUCTVIEW.LENGTH',
			'dimensionsStep.height': 'PRODUCTVIEW.HEIGHT',
			'dimensionsStep.weight': 'PRODUCTVIEW.KILOGRAMS',
			'dimensionsStep.dimensionUnit': 'PRODUCTVIEW.DIMENSIONUNIT',
			'dimensionsStep.weightUnit': 'PRODUCTVIEW.WEIGHTUNIT',
			'dimensionsStep.box': 'PRODUCTVIEW.BOX',
			'dimensionsStep.automaticBox': 'PRODUCTVIEW.AUTOMATICBOX',
			'dimensionsStep.ounces': 'PRODUCTVIEW.OUNCES',
			'dimensionsStep.pounds': 'PRODUCTVIEW.POUNDS',
		},
		rules: {
			'dimensionsStep.width': 'required|numeric|notZero|numericMinValue|decimalLength',
			'dimensionsStep.length': 'required|numeric|notZero|numericMinValue|decimalLength',
			'dimensionsStep.height': 'required|numeric|notZero|numericMinValue|decimalLength',
			'dimensionsStep.dimensionUnit': 'required',
			'dimensionsStep.weightUnit': 'required',
		},
	};
}

export default DimensionsStepEditForm;



// WEBPACK FOOTER //
// ./src/modules/product/wizard/forms/DimensionsStepEditForm.js